export default {"src":"/_next/static/media/step1g.df4c785d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};